import { Card, Switch, Text } from '~src/components/display';
import { useLocalization, useToastMessage } from '~src/hooks';
import { useUpsertResidence } from '~src/hooks/services';
import { ResidenceInput } from '~src/types';

type HasExistingSolarPanelsToggleProps = { customerID?: number; residence?: ResidenceInput };

export const HasExistingSolarPanelsToggle = ({ customerID, residence }: HasExistingSolarPanelsToggleProps) => {
  const translate = useLocalization();
  const { showMessage } = useToastMessage();

  const { upsertResidence } = useUpsertResidence();

  if (!customerID || !residence) {
    return null;
  }

  const setHasExistingSolarPanels = async (newValue: boolean) => {
    const updated: ResidenceInput = {
      ...residence,
      hasExistingSolarPanels: newValue,
    };

    await upsertResidence(customerID, updated);

    showMessage({ type: 'success', message: translate.SAVED });
  };

  const hasExistingSolarPanels = residence?.hasExistingSolarPanels ?? false;

  return (
    <Card title={translate.EXISTING_SOLAR_PANELS}>
      <Text>{translate.HAS_SOLAR_PANELS_ALREADY}</Text>

      <Switch defaultChecked={hasExistingSolarPanels} onChange={newValue => setHasExistingSolarPanels(newValue)} />
    </Card>
  );
};
